import { AbstractControl, ValidatorFn } from '@angular/forms';
export function cyrillicTextValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {

    if (!control.value || control.value === '') {
      return null;
    }

    const URL_REGEXP = /^([а-яА-Я0 -]+)$/;

    if (URL_REGEXP.test(control.value)) {
      return null;
    }
    return {
      invalidCyrillicText: true
    };
  };
}
